import Typography from 'typography';
import loadTheme from './themes';

const defaultTable = ({ rhythm, adjustFontSizeTo }, options) => ({
  table: {
    ...adjustFontSizeTo(options.baseFontSize),
    borderCollapse: 'collapse',
    width: '100%',
  },
  thead: {
    textAlign: 'left',
  },
  'td,th': {
    textAlign: 'left',
    borderLeft: '1px solid #333333',
    borderTop: '1px solid #333333',
    borderRight: '1px solid #333333',
    borderBottom: '1px solid #333333',
    fontFeatureSettings: '"tnum"',
    MozFontFeatureSettings: '"tnum"',
    msFontFeatureSettings: '"tnum"',
    WebkitFontFeatureSettings: '"tnum"',
    paddingLeft: rhythm(2 / 3),
    paddingRight: rhythm(2 / 3),
    paddingTop: rhythm(1 / 2),
    paddingBottom: `calc(${rhythm(1 / 2)} - 1px)`,
  },
  'th:first-child,td:first-child': {
    paddingLeft: '',
  },
  'th:last-child,td:last-child': {
    paddingRight: '',
  },
  mark: {
    backgroundColor: 'unset',
    color: 'unset',
  },
});

export default async function mergeThemeAndConfig(config = {}, themeName) {
  if (themeName) {
    const theme = await loadTheme(themeName);

    theme.default.overrideStyles = defaultTable;
    return new Typography(theme.default);
  }

  return new Typography({
    ...config,
    overrideStyles: defaultTable,
  });
}
